import {WarehouseAdminResupplyReason} from "@/http/data/warehouse-admin-resupply-task-data";

export default class WarehouseAdminResupplyTasksRequest {
    constructor(
        private readonly building: string|null = null,
        private readonly reason: WarehouseAdminResupplyReason|null = null,
        private readonly from: string|null = null,
        private readonly until: string|null = null
    ) {}

    toJson(): {
        building: string|null;
        reason: WarehouseAdminResupplyReason|null;
        from: string|null;
        until: string|null;
    } {
        return {
            building: this.building,
            reason: this.reason,
            from: this.from,
            until: this.until
        };
    }
}